import { render, staticRenderFns } from "./salary_match_config_edit.vue?vue&type=template&id=60e0c451&scoped=true"
import script from "./salary_match_config_edit.vue?vue&type=script&lang=js"
export * from "./salary_match_config_edit.vue?vue&type=script&lang=js"
import style0 from "./salary_match_config_edit.vue?vue&type=style&index=0&id=60e0c451&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e0c451",
  null
  
)

export default component.exports